import {Button, Modal} from "@matillion/component-library";
import { EulaText } from "./EulaText";
import Styles from "./EulaStyle.module.scss"
import {useAcceptEula} from "./useAcceptEula.ts";

export function EulaPopup() {
    const [accepted, isLoading, accept] = useAcceptEula()
    if(accepted) return null
    return <Modal disableBackdropClick size="large" onCancel={() => {}} ariaLabelledBy={"EULA"} className={Styles.Eula}>
        <p>
            {EulaText}
        </p>
        <div className={Styles.ButtonContainer}>
            <Button onClick={accept} alt="positive" waiting={isLoading} >I Accept</Button>
            <Button onClick={() => { window.location.href = "https://matillion.com" }} alt="danger" >I Do Not Accept</Button>
        </div>
    </Modal>
}